import MapView from '@arcgis/core/views/MapView';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { Tool, ToolSlot } from '../framework/Tool';
import { SurfaceDef } from '../model/SurfaceDef';
import { DeletePointBreaklineInputTask } from './DeletePointBreaklineInputTask';
import { onCancelBreaklineOperation, onExecuteBreaklineOperation } from '../utils/ToolUtils';

export class DeletePointBreaklineTool extends Tool {
    private readonly mapView: MapView;
    private readonly surfaceDef: SurfaceDef;
    private readonly breaklinesLayer: GraphicsLayer;
    private task: DeletePointBreaklineInputTask;

    constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, breaklinesLayer: GraphicsLayer) {
        super('Delete Point Breakline Tool', 'single', toolSlot);
        this.mapView = mapView;
        this.surfaceDef = surfaceDef;
        this.breaklinesLayer = breaklinesLayer;
        this.task = new DeletePointBreaklineInputTask(mapView, surfaceDef);
    }
    protected async onExecuteOperation(): Promise<void> {
        await onExecuteBreaklineOperation(this.task, this.breaklinesLayer, this.surfaceDef.breaklinesSyncSet, this.mapView.spatialReference);
    }

    protected async onCancelOperation(): Promise<void> {
        await onCancelBreaklineOperation(this.task);
    }
}
